import { convertUTCToLocalISOString, formatDate, formatShortDate } from "@/Modules/utils/dateFormatter";

export function mapToLocalTimezone(array) {
  return array.map((item) => ({
    ...item, 
    endTime: convertUTCToLocalISOString(item.endTime),
    startTime: convertUTCToLocalISOString(item.startTime),
  }));
}

export function mapDateToObject(input) {
  let originalValue = input;
  let isoString = "";
  let short = "";
  let full = "";

  if (input instanceof Date) {
    isoString = convertUTCToLocalISOString(input);
  }
  else if (typeof input === "string" && input.includes("T")) {
    isoString = input;
  }
  else if (typeof input === "number" || (typeof input === "string" && !isNaN(new Date(input).getTime()))) {
    const date = new Date(input);
    originalValue = date;
    isoString = convertUTCToLocalISOString(date);
  }

  if (isoString) {
    short = formatShortDate(isoString);
    full = formatDate(isoString);
  } else {
    short = full = String(input ?? "");
  }

  return {
    short,
    full,
    original: originalValue
  };
}